import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import { LightRequestsService } from '@/services/services/requests.service';
import BaseModule from '@/store/baseModule';
import {
  countRequestStates,
  getAllRequestStates,
  getRecentRequests,
  groupbySymptom,
  groupbyCustomer,
  sortFinishedAndRejected,
} from './customGetters';

export default (store) => {
  store.registerModule(
    ['properties', 'requests'],
    new BaseModule({
      serviceAPI: LightRequestsService,
      defaultSortBy: ['signalisation_datetime'],
      customGetters: {
        isRecurrence: (state) =>
          getRecentRequests(state.items.data, 15).length > 1,
        countByStates: (state) => countRequestStates(state.items.data),
        activeItems: (state) => getAllRequestStates(state.items.data),
        last24hItems: (state) => getRecentRequests(state.items.data, 1),
        last24hFilteredItems: (state) =>
          groupbySymptom(getRecentRequests(state.items.data, 1)),
        last15dItems: (state) => getRecentRequests(state.items.data, 15),
        last15dSortedItems: (state) =>
          sortFinishedAndRejected(getRecentRequests(state.items.data, 15)),
        customersSortedItems: (state) =>
          groupbyCustomer(getRecentRequests(state.items.data, 15)),
      },
      makeQueryParams: makeListRequest({
        limitItemsRequest: 100,
      }),
    })
  );

  const basePlugin = new BaseModulePlugins({
    paramId: 'propertyId',
    module: 'properties/requests',
    store,
  });

  basePlugin.onInit(() => {
    basePlugin.changeParamOnRequestChange('property_id');
  });
};
